<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <button @click="click_event">click event</button>
    <!-- <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>المحادثات الرسمية</v-toolbar-title>
      </v-toolbar>

      <v-layout wrap>
        <v-flex
          xs3
          sm3
          md3
          style="border:1px solid red;max-height:600px;height:600px;overflow-y: scroll;"
        >
          <div
            class="user_chat"
            v-for="user in users"
            :key="user.id"
            @click="get_my_chat(user)"
          >
            {{ user.employer.name }}
            <span v-if="user.mysms.length > 0" class="sms_no">{{
              user.mysms.length > 0 ? user.mysms.length : ""
            }}</span>
          </div>
        </v-flex>
        <v-flex xs9 sm9 md9 style="border:1px solid red;">
          <div style="overflow-y: scroll;max-height:500px;height:500px">
            <p
              v-for="m in messages"
              :key="m.id"
              :class="{
                receive: m.user_from != user.id,
                am: m.user_from == user.id
              }"
            >
              {{ m.message }}

              <span>{{ m.created_at }}</span>
            </p>
          </div>
          <div style="max-height:100px;height:100px" v-if="user_active">
            <textarea
              name=""
              v-model="new_message"
              placeholder="................................................................................"
              style="width:80%;height:100%;border:1px solid"
              id=""
              rows=""
            ></textarea>
            <button
              @click="add_new_message"
              style="background-color:yellow;width:20%;height:100%;float:left"
            >
              <v-icon>ارسال</v-icon>
            </button>
          </div>
        </v-flex>
      </v-layout>
    </v-container> -->
  </div>
</template>

<script>
import { users_chat, get_chat, add_new_message,click_event } from "../config/apiRoute.js";
export default {
  data: () => ({
    users: [],
    loading: false,
    messages: [],
    user: "",
    permissions: "",
    user_active: "",
    new_message: ""
  }),

  computed: {},

  created() {
    this.$echo.channel("mychannel").listen("ClickEvent", payload => {
      console.log(payload);
      console.log('payload');
    });
    this.$echo
      .join(`online`)
      .here(users => {
        console.log(users);
      })
      .joining(user => {
        console.log(user);
      })
      .leaving(user => {
        console.log(user);
      });
    // this.loading = true;
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    // users_chat().then(res => {
    //   this.loading = false;
    //   this.users = res.data;
    // });
  },

  methods: {
    click_event(){
      click_event().then(res=>{
        console.log('clicked event')
      })
    },
    get_my_chat(user) {
      this.loading = true;
      this.user_active = user;
      var frmData = new FormData();
      frmData.append("user_id", user.id);
      get_chat(frmData).then(res => {
        this.loading = false;
        this.messages = res.data;
      });
    },
    add_new_message() {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("message", this.new_message);
      frmData.append("user_from", this.user.id);
      frmData.append("user_to", this.user_active.id);
      add_new_message(frmData).then(res => {
        this.loading = false;
        this.messages.push(res.data);
        this.new_message = "";
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.user_chat {
  padding: 10px 5px 10px 10px;
  border-bottom: 1px solid red;
  background-color: #ccc;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}
.receive {
  text-align: left;
  padding: 20px;
  background-color: #dbb7b7;
  width: 350px;
  display: block;
  border-radius: 0px 20px 20px 0px;
  font-size: 20px;
  margin-right: auto;
}
.am {
  text-align: right;
  padding: 20px;
  background-color: #123fe1;
  width: 350px;
  display: block;
  border-radius: 20px 0px 0px 20px;
  font-size: 20px;
  margin-left: auto;
}
.receive span {
  font-size: 9px;
  text-align: right;
  display: block;
  color: yellow;
}
.am span {
  font-size: 9px;
  text-align: left;
  display: block;
  color: yellow;
}
.sms_no {
  background-color: #06fa19;
  padding: 3px;
  border-radius: 50%;
  font-size: 10px;
  color: #aa0beb;
  float: left;
}
</style>
